import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import type { VehicleId } from '../../types/gcs/vehicle';
import type { MissionId } from '../../types/gcs/mission';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';
import { getShortVehicleId } from '../../utils/formatters';

interface ConfirmEmergencyLandDialogProps {
  gcsId: string;
  vehicleId: VehicleId;
  missionId: MissionId;
  onClose: () => void;
}

function ConfirmEmergencyLandDialog({ gcsId, vehicleId, missionId, onClose }: ConfirmEmergencyLandDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [emergencyLandAction, setEmergencyLandAction] = useState<AsyncAction>(AsyncAction.initial());
  const emergencyLand = useGcsStore((state) => state.emergencyLand);
  const vehicleLabel = getShortVehicleId(vehicleId);

  const onConfirmClicked = async () => {
    try {
      setEmergencyLandAction(AsyncAction.loading());
      await emergencyLand(gcsId, missionId);
      setEmergencyLandAction(AsyncAction.success(undefined));
      onClose();
    } catch (error) {
      setEmergencyLandAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmEmergencyLandDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmEmergencyLandDialog.landButton,
        callback: onConfirmClicked,
        isLoading: emergencyLandAction.isLoading,
        backgroundColor: 'var(--color-danger)',
        foregroundColor: '#ffffff'
      }}
      errorText={emergencyLandAction.isFailure ? getLocalizedErrorMessage(emergencyLandAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmEmergencyLandDialog.body.replace('{vehicle}', vehicleLabel)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmEmergencyLandDialog;
